import { useContext } from 'react';

import { Formatter } from '@ravago/shared/translations';

import { TranslationsContext } from '../contexts/translations-context';
import { TranslateFn } from '../models/translate-fn.model';
import { TranslationPlaceholders } from '../models/translation-placeholders.model';
import { translate } from '../utils/translation/translation.utils';

export const useTranslations = (): TranslateFn => {
   const translationsContext = useContext(TranslationsContext);
   const formatter = new Formatter(translationsContext.locale);

   if (!translationsContext) {
      throw new Error('useTranslations must be used within a TranslationsContextProvider');
   }

   return (key: string, placeholders?: TranslationPlaceholders, forceFallback?: boolean) =>
      translate(formatter, key, translationsContext?.translations ?? null, translationsContext?.fallback ?? null, placeholders, forceFallback);
};
